/**
 * @file ModernPendingEditedRow.tsx
 * @description This file contains the ModernPendingEditedRow component. It
 * is a re-skin of the PendingEditedRow component.
 */

import React from "react";

import { RowType } from "./modernPendingChangesUtils";
import { MdArrowDownward } from "react-icons/md";
import { Header } from "../../Components/StickyTable";

import "./ModernPendingChangesPanel.scss";

interface ModernPendingEditedRowProps<R> {
  oldRow: R;
  newRow: R;
  columns: Header[];
}

const ModernPendingEditedRow = <R extends RowType>({
  oldRow,
  newRow,
  columns,
}: ModernPendingEditedRowProps<R>): JSX.Element => {
  return (
    <div className="pendingChangesRowContainer pendingEditRowContainer">
      {columns.map(col => {
        const { label, field, renderer } = col;
        const oldVal = oldRow[field || ""] || "null";
        const newVal = newRow[field || ""] || "null";
        return (
          <div key={label}>
            {field &&
            (Array.isArray(oldRow[field]) || typeof oldRow[field] === "string") &&
            (Array.isArray(newRow[field]) || typeof newRow[field] === "string") &&
            oldVal !== newVal ? (
              <div className="pendingChangesRow">
                <b className="pendingChangesRowLabel">{label}:</b>
                <div className="pendingChangesRowVal">
                  {(() => {
                    const oldArr =
                      field && Array.isArray(oldRow[field])
                        ? oldRow[field]
                        : field && typeof oldRow[field] === "string"
                        ? oldRow[field].split(/[,;\s]+/).filter(Boolean)
                        : [];
                    const newArr =
                      field && Array.isArray(newRow[field])
                        ? newRow[field]
                        : field && typeof newRow[field] === "string"
                        ? newRow[field].split(/[,;\s]+/).filter(Boolean)
                        : [];
                    const added = newArr.filter(e => !oldArr.includes(e));
                    const removed = oldArr.filter(e => !newArr.includes(e));
                    return (
                      <>
                        {removed.map(val => (
                          <div key={`removed-${val}`} style={{ color: "#dc143c" }}>
                            - {val}
                          </div>
                        ))}
                        {added.map(val => (
                          <div key={`added-${val}`} style={{ color: "green" }}>
                            + {val}
                          </div>
                        ))}
                      </>
                    );
                  })()}
                </div>
              </div>
            ) : oldVal !== newVal ? (
              <div className="pendingChangesRow">
                <b className="pendingChangesRowLabel">{label}:</b>
                <div className="pendingChangesRowVal">
                  <div className="oldVal">{renderer ? renderer(oldRow) : oldVal}</div>
                  <div className="pendingChangesArrow">
                    <MdArrowDownward />
                  </div>
                  <div className="newVal">{renderer ? renderer(newRow) : newVal}</div>
                </div>
              </div>
            ) : (
              <div className="pendingChangesRow">
                <b className="pendingChangesRowLabel">{label}:</b>
                <div>{renderer ? renderer(newRow) : newVal}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ModernPendingEditedRow;
